// FLOW Platform — English accept-list (the "big list").
//
// Wordle keeps two word lists: a small answer list and a much larger
// list of words it will ACCEPT as guesses (~13K). thruWord does the
// same. The compound graph is the answer universe; this module loads
// the accept universe — the full ENABLE dictionary (public domain,
// ~152K words after filtering to lowercase a-z, 2-12 letters) unioned
// with the game's own compound vocabulary so no answer word can ever
// be rejected.
//
// The list is ~1.4MB raw / ~450KB gzipped, fetched once in the
// background after the page renders and then browser-cached (the URL
// carries the plugin version, so it re-fetches only on upgrades).
// Until it arrives, game.js falls back to the compound vocabulary —
// strict for a moment, never broken.

let dict = null;      // Set of lowercase words once loaded
let started = false;

function start() {
  if (started) return;
  started = true;
  const cfg = (typeof window !== 'undefined' && window.flowFhtConfig) || {};
  if (!cfg.dictUrl || typeof fetch !== 'function') return;
  fetch(cfg.dictUrl)
    .then((r) => (r.ok ? r.text() : null))
    .then((text) => {
      if (!text) return;
      dict = new Set(text.split('\n'));
    })
    .catch(() => { /* stay null; the compound-vocab fallback covers */ });
}

// Kick off the download as soon as the page is ready — well before the
// player's first submit in any realistic session.
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}

/**
 * Is this a real English word per the accept-list?
 * Returns true / false, or null if the list hasn't finished loading —
 * callers should fall back to the compound vocabulary on null.
 */
export function isDictWord(w) {
  if (dict === null) return null;
  return dict.has(String(w || '').toLowerCase());
}
